// Centralised JSON-LD schema generators for VAROTRADES.
// Used by <JsonLd /> across the site for rich search snippets.

const SITE_URL = 'https://www.varotrades.com';
const LOGO_URL = `${SITE_URL}/varotrade_official_emblem.png`;

export const organizationSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'VAROTRADE SERVICES LTD',
  alternateName: 'VAROTRADES',
  url: SITE_URL,
  logo: LOGO_URL,
  foundingDate: '2021',
  description:
    'VAROTRADE SERVICES LTD is a licensed and regulated international CFD broker offering Forex, Indices, Commodities, Shares, ETFs and Bonds across 50+ countries.',
  legalName: 'VAROTRADE SERVICES LTD',
  taxID: 'C179725',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '6th Floor, Tower 1, Nexteracom Building',
    addressLocality: 'Ebene',
    addressCountry: 'MU',
  },
  hasCredential: [
    {
      '@type': 'EducationalOccupationalCredential',
      credentialCategory: 'license',
      recognizedBy: {
        '@type': 'Organization',
        name: 'Financial Services Commission of Mauritius',
        url: 'https://www.fscmauritius.org',
      },
      identifier: 'GB21026396',
      name: 'Securities Dealer (Full Service Dealer)',
    },
  ],
  sameAs: [
    'https://twitter.com/varotrades',
    'https://www.facebook.com/varotrades',
    'https://www.linkedin.com/company/varotrades',
    'https://www.youtube.com/@varotrades',
    'https://t.me/varotrades',
  ],
});

export const financialServiceSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FinancialService',
  '@id': `${SITE_URL}/#financial-service`,
  name: 'VAROTRADES — CFD Trading',
  url: SITE_URL,
  image: LOGO_URL,
  parentOrganization: { '@id': `${SITE_URL}/#organization` },
  areaServed: { '@type': 'Place', name: 'Worldwide (50+ countries)' },
  priceRange: '$$',
  serviceType: ['Forex Trading', 'Indices', 'Commodities', 'Shares CFDs', 'ETFs', 'Bonds'],
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.8',
    reviewCount: '12450',
    bestRating: '5',
    worstRating: '1',
  },
});

export const websiteSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${SITE_URL}/#website`,
  url: SITE_URL,
  name: 'VAROTRADES',
  publisher: { '@id': `${SITE_URL}/#organization` },
  inLanguage: ['ar', 'en'],
  potentialAction: {
    '@type': 'SearchAction',
    target: `${SITE_URL}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
});

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((it, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: it.name,
    item: it.url.startsWith('http') ? it.url : `${SITE_URL}${it.url}`,
  })),
});

export const faqSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
});
